import React from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import { Link } from 'react-browser-router';


function PypFaq() {
    return (
        <Accordion preExpanded={['a']}>
            <AccordionItem uuid="a" >
                <AccordionItemHeading>
                    <AccordionItemButton>
                    So, what actually is a “Unit of Inquiry”?


                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    A Unit of Inquiry usually lasts for 4-6 weeks. The objective is to cover all six themes throughout the year. For example, during the Unit of Inquiry “Sharing the Planet” students may spend six weeks looking at the resources we have in the world and how various countries use, share and dispose off these resources. Students will answer questions like: How do these resources connect people around the world? Or, how are these resources changing and what does that mean for people? These concepts and questions move across all school subjects (i.e. Math, English, Geography, etc.) and apply to real life and the world around us.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="b">
                <AccordionItemHeading>
                    <AccordionItemButton>
                    And, how does Sanskar implement these Units of Inquiry?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    These Units of Inquiry form the Sanskar Program of Inquiry on which our teachers build students’ concepts, knowledge, and skills. The themes provide the structure to articulate subject -specific knowledge from Pre-Primary to Grade 5. With the IB PYP, however,the priority is not on using a set of textbooks, but rather the emphasis is on a wide variety of resources from which teachers and students extract knowledge, develop understanding, and explore ways of applying that to real life.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="c">
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Why less use of textbooks?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    The IB PYP philosophy believes that students learn best through authentic inquiry. While there is certainly a place in the curriculum for some use of textbooks and workbooks, Sanskar uses a wide range of primary and secondary resources that cater best to its students’ individual needs and learning styles. Textbooks do so much of the work for a child that they inhibit development of the critical thinking skills necessary to become a successful life-long learner. The IB PYP also recognizes that it is not knowledge alone that makes a learner successful, but the skills and attitudes they develop along the way.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="d">
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Please tell me what is a RUBRIC?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    A rubric defines what are the standards or requirements that need to be accomplished in order to achieve the overall target or goal. Students should be able to use rubrics in many of the  ways that teachers use them - to clarify the standards for a quality performance, and to guide ongoing feedback about progress toword those standards.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="e">
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Explain to me a little more about how my child will be assessed at Sanskar SCHOOL?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    At Sanskar, each Unit of Inquiry allows students opportunities to demonstrate that learning is taking place—that there is a shifts,  understanding. This may look different across all subject areas—however, this shift in understanding is not always best demonstrated through a piece of written work or a traditional exam. Students may be asked to put together a final project, draw, act out a performance, do a presentation, or some other way to show what they have learned. The goal is for our students to demonstrate that learning has taken place by showing what they understand and how they are applying that understanding to real life and the world around them. At Sanskar, we believe that assessment is the continuation of the learning process. It is NOT assessment of learning, but it is assessment for learning. The IB views assessment as needing to be authentic, essential, rich, engaging, and feasible—it should incorporate students in the process of evaluating their learning. “Formative” assessment is interwoven into the daily lessons and learning—this ongoing process of “checking in” between teachers and students, helps both teachers and students find out what they already know, in order to plan for the next stage of learning. “Formative” assessment and teaching are directly linked; effective learning cannot take place without one or the other. “Summative” assessment takes place at the end of the teaching and learning process—this is the time that students have the opportunity to demonstrate their understanding and application of what has been learned.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="f">
                <AccordionItemHeading>
                    <AccordionItemButton>
                    How can parents help students with school work?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Follow up daily with your child to see what homework they have. Help reinforce at home the lessons learnt in class and fulfill the requirements for the next day daily. Help your ward schedule time so they don’t feel overburdened. Realize that you will probably help them with (not do) some of their larger projects. Most parents find pleasure or pride in helping their child grow in this way.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="g">
                <AccordionItemHeading>
                    <AccordionItemButton>
                    How can I, as a PARENT, get involved in the PYP?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Volunteer to become a Primary Resource Parent by filling in a “Parent as Primary Resource” voucher and share your expertise. Ask children about the theme, central idea, and concepts that they are inquiring into. Show interest in their units of inquiry and plan activities around them whenever you can. Encourage your children to “find out” rather than telling them answers. Ask children about the Learner Profile attributes – point them out in other people, in yourself, in your children’s actions and speech. In terms of keeping contacts you are always welcome at Sanskar. We need your support and assistance to make our school ever greater.
                    </p>
                   
                </AccordionItemPanel>
            </AccordionItem>
            
        </Accordion>
    );
}

export default PypFaq
